import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/module'

const DEFAULT_SIZE = 1000;

const LIST_API = `${API_PREFIX}/list`

const RECEIVE_LIST = `MODULE_RECEIVE_LIST`

export const CHANGE_PAGE = `MODULE_CHANGE_PAGE`

export const SHOW_MODAL = `MODULE_SHOW_MODAL`

export const HIDE_MODAL = `MODULE_HIDE_MODAL`

export const CHANGE_SETTING = `MODULE_CHANGE_SETTING`

export const UPDATE_INFO = `MODULE_UPDATE_INFO`

export const RECEIVE_ROLE_LIST = `MODULE_RECEIVE_ROLE_LIST`

//action
function getData(params,dispatch) {
    return http.get(`${LIST_API}?${qs.stringify(params)}`)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}

export function getList() {
    return (dispatch,getState) => {
        const {modules: {page}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        getData(data,dispatch)
    };
}

export function add(formData) {
    return (dispatch) => {
        return Promise.resolve([
            http.post(`/njs/codeauto`,formData),
            http.post(`/codeauto/create`,formData),
        ])
        .then(() => {
            dispatch({type: HIDE_MODAL})
            dispatch(getList())
        })
    }
}

export function remove(id) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/delete/${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function update() {
    return (dispatch,getState) => {
        const {modules: {showModal: {id,isClose}}} = getState()
        const formData = { isClose }
        return http.post(`${API_PREFIX}/update/${id}`,formData)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}

export function getRoleList() {
    return (dispatch,getState) => {
        return http.get(`/role/list`)
            .then(data => {
                dispatch({
                    type: RECEIVE_ROLE_LIST,
                    data: data.data.list
                })
            })
    }
}

//reducers
const initialState = {
    list: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        add: false,
        delete: false,
        detail: false,
        close: false,
        id: null,
        content: null,
        isClose: ''
    },
    module: {
        name: '',
        path: '',
        parentId: ''
    },
    roles: []
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id,content,isClose,row}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id,content,isClose,row: {...row}}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal}
    },
    [CHANGE_SETTING]: (state,{value,key}) => {
        return {...state,module: {...state.module,[key]: value}}
    },
    [UPDATE_INFO]: (state,{value,key}) => {
        return {...state,showModal:{...state.showModal,row: {...state.showModal.row,[key]: value}}}
    },
    [RECEIVE_ROLE_LIST]: (state,{data}) => {
        return {...state, roles: data}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/modules/reducers/list.js